import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { find } from 'lodash';
import { CYCLES, CYCLE_LABELS } from '@src/constants';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { useBillingPricingAndNextPaymentQuery } from '@src/graphql/generated';
import './styles.scss';

const _PricingAndNextPayment = ({ selectedCycle, selectedPlanType, setErrorFlashMessage }) => {
  const { loading, error, data } = useBillingPricingAndNextPaymentQuery({
    onError: () => setErrorFlashMessage(),
  });

  if (loading || error) {
    return null;
  }

  const {
    subscriptionPlans,
    availableCurrencies,
    customer: {
      planType,
      planInfo: { cycle, nextPaymentDate },
    },
  } = data;

  const subscriptionCycle = selectedCycle || cycle;
  const { variants } = find(subscriptionPlans, { planType: selectedPlanType || planType });
  const { price, currency } = find(variants, ['cycle', subscriptionCycle]);

  return (
    <div className="pricing-next-payment">
      <div className="pricing-next-payment__details">
        <div className="pricing-next-payment__details-name">Pricing</div>
        <div className="pricing-next-payment__details-value">
          {find(availableCurrencies, { code: currency.toUpperCase() }).symbol}
          <strong>{price}</strong>
          {CYCLE_LABELS[subscriptionCycle]}
        </div>
      </div>

      <div className="pricing-next-payment__details pricing-next-payment__details--border-top">
        <div className="pricing-next-payment__details-name">Next payment date</div>
        <div className="pricing-next-payment__details-value">{moment(nextPaymentDate).format('DD MMM YYYY')}</div>
      </div>
    </div>
  );
};

_PricingAndNextPayment.propTypes = {
  selectedCycle: PropTypes.oneOf(Object.values(CYCLES)),
  selectedPlanType: PropTypes.string,
  setErrorFlashMessage: PropTypes.func.isRequired,
};

export const PricingAndNextPayment = connect(null, { setErrorFlashMessage })(_PricingAndNextPayment);
